import constants from '../constants';

export default function cashOutReducer(cashOut = {}, action) {
  switch (action.type) {
    default:
      return cashOut;
  }
}
